import React from "react";
import { useApi } from "../apis";
import { useStores } from "../stores";

export function useLoadUsersInPlan(planUid: string | undefined) {
  const { usersApi } = useApi();
  const { plansStore } = useStores();
  const { usersStore } = useStores();

  const plan = planUid ? plansStore.byId.get(planUid) : undefined;

  React.useEffect(() => {
    if (plan?.data.userIds) {
      // Get all archived users as well
      plan.data.userIds.forEach((uid) => {
        if (!usersStore.byId.get(uid)) {
          usersApi.getById(uid);
        }
      });
    }

    if (plan?.data.archive.userIds.length) {
      // Get all archived users as well
      plan.data.archive.userIds.forEach((uid) => {
        if (!usersStore.byId.get(uid)) {
          usersApi.getById(uid);
        }
      });
    }

    if (plan?.data.ghostUsers.length) {
      // Get all ghost users as well
      plan.data.ghostUsers.forEach((uid) => {
        if (!usersStore.byId.get(uid)) {
          usersApi.getById(uid);
        }
      });
    }

    if (plan?.data.joinOptions?.waitingForApproval?.length) {
      // Get all users applying as well
      plan?.data.joinOptions?.waitingForApproval.forEach((uid) => {
        if (!usersStore.byId.get(uid)) {
          usersApi.getById(uid);
        }
      });
    }
  }, [
    usersApi,
    plan,
    usersStore,
    plan?.data.userIds,
    plan?.data.joinOptions,
    plan?.data.archive.userIds,
  ]);
}
